<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ data?.title || 'Create them as Admin Controlled?' }}</h2>
    <button type="button" mat-icon-button class="close-button" (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-body">
    <ng-container *ngIf="useConsentLayout; else legacyLayout">
      <p class="lead" [innerHTML]="data.leadHtml"></p>

      <div class="ss-impact" *ngIf="data.impactHeading || (data.impactLines && data.impactLines.length)">
        <strong>{{ data.impactHeading || 'What changes for them' }}</strong>
        <ul *ngIf="data.impactLines?.length">
          <li *ngFor="let line of data.impactLines">{{ line }}</li>
          <li *ngIf="data.conditionalLine">{{ data.conditionalLine }}</li>
        </ul>
      </div>

      <p class="next-step" *ngIf="data.nextStepHtml" [innerHTML]="data.nextStepHtml"></p>
    </ng-container>

    <ng-template #legacyLayout>
      <p class="lead" *ngIf="data?.textHtml; else defaultLead" [innerHTML]="data.textHtml"></p>
      <ng-template #defaultLead>
        <p class="lead">{{ data?.subtitle || 'They will sign in. They cannot pause tracking.' }}</p>
      </ng-template>
      <ul class="impact-list">
        <li *ngFor="let b of (data?.bullets || defaultBullets)">{{ b }}</li>
      </ul>
    </ng-template>
  </div>

  <div mat-dialog-actions class="dialog-actions" [class.with-dont-show]="showDontShowCheckbox">
    <mat-checkbox *ngIf="showDontShowCheckbox" [(ngModel)]="dontShowAgain" class="dont-show">
      Don't show this again
    </mat-checkbox>
    <div class="actions-right">
      <button mat-stroked-button type="button" class="cancel-btn" (click)="onCancel()">
        {{ data?.cancelText || 'Cancel' }}
      </button>
      <button mat-flat-button type="button" class="confirm-btn" (click)="onConfirm()">
        {{ data?.confirmText || 'Create as Admin Controlled' }}
      </button>
    </div>
  </div>
</div>
